/**
 * @file 试卷页框
 * @description 把分页结果套进 A4 页眉页脚。
 *
 * @whenToUse 三套打印模板渲染每一页。
 * @whenNotToUse 非 A4 的后台界面。
 */

import type { RefObject } from 'react'
import type { CSSProperties } from 'react'
import {
  BlockView,
  PagerFooter,
  PagerHeader,
  type PaperBlock,
  type PaperHeaderInfo,
} from '@/components/pages/handout-page/print/blocks.tsx'

/**
 * 渲染已分页的 A4 试卷。
 */
export function PaperPages({
  pages,
  ready,
  rootRef,
  containers,
  header,
  headerStyle,
}: {
  /** 各页内容 */
  pages: PaperBlock[][]
  /** 分页是否结束 */
  ready: boolean
  /** 模板根节点 */
  rootRef: RefObject<HTMLDivElement | null>
  /** 每页内容容器，供测高 */
  containers: RefObject<(HTMLElement | null)[]>
  /** 页眉 */
  header: PaperHeaderInfo
  /** 页眉内联样式 */
  headerStyle?: CSSProperties
}) {
  return (
    <div
      ref={rootRef}
      className="pdf-wrapper"
      data-pagination-ready={ready ? '1' : '0'}
    >
      {pages.map((page, paperIdx) => (
        <div
          key={paperIdx}
          className={
            paperIdx < pages.length - 1
              ? 'template-wrapper pdf-page-break'
              : 'template-wrapper'
          }
        >
          <PagerHeader info={header} style={headerStyle} />
          <div className="paper-question-container">
            <div
              ref={(el) => {
                containers.current[paperIdx] = el
              }}
            >
              {page.map((block, index) => (
                <BlockView key={`${block.type}-${index}`} block={block} />
              ))}
            </div>
          </div>
          <PagerFooter page={paperIdx + 1} total={pages.length} />
        </div>
      ))}
    </div>
  )
}
